import { hasClass } from '../../utils/dom';

const keyboardCls = 'is-keyboard-event';

export default {
  data() {
    return {
      x: -1,
      y: -1,
      focusCheckBox: null,
      activedescendant: null
    };
  },

  computed: {
    focusIndex() {
      if (this.x === -1 || this.y === -1) {
        return -1;
      }
      return this.y * this.columnCount + this.x;
    },
    checkboxAllDisabled() {
      return this.checkboxes.every(option => option.disabled);
    }
  },

  mounted() {
    document.addEventListener('click', this.checkActiveElement);
  },

  beforeDestroy() {
    document.removeEventListener('click', this.checkActiveElement);
  },

  watch: {
    focusIndex(val) {
      if (typeof val === 'number' && val > -1) {
        this.focusCheckBox = this.checkboxes[val] || {};
      } else {
        this.focusCheckBox = null;
      }
      this.checkboxes.forEach(checkbox => {
        if (this.focusCheckBox === checkbox) {
          checkbox.focus();
        }
      });
    }
  },

  methods: {
    onFocus() {
      if (this.useMouse() || this.checkboxAllDisabled) {
        return;
      }
      let checkbox;
      if (this.x === -1 && this.y === -1) {
        this.x = 0;
        this.y = 0;
        checkbox = this.checkboxes[0];
        while (checkbox.disabled) {
          if ((this.x + 1) % this.columnCount === 0) {
            this.x = 0;
            if ((this.y + 1) * this.columnCount >= this.checkboxes.length) {
              return;
            } else {
              this.y++;
            }
          } else {
            this.x++;
          }
          checkbox = this.checkboxes[this.x + this.y * this.columnCount];
        }
        this.activedescendant = checkbox.itemId;
      }
      setTimeout(() => {
        if (!this.focusCheckBox) {
          checkbox.focus();
        } else {
          this.focusCheckBox.focus();
        }
        // make shift tab work
        this.$el.tabIndex = -1;
      }, 20);
    },
    onTab() {
      // reset tabIndex so that the list can be focus then.
      setTimeout(() => {
        this.$el.tabIndex = 0;
      }, 20);
    },
    checkActiveElement() {
      if (!this.$el.contains(document.activeElement)) {
        this.$el.tabIndex = 0;
      }
    },
    useMouse() {
      return !hasClass(document.body, keyboardCls);
    },
    navigateCheckbox(direction) {
      const currentX = this.x;
      const currentY = this.y;
      if (this.checkboxes.length === 0 || this.checkboxAllDisabled) {
        return false;
      }
      this.bottom = false;
      this.top = false;
      this.left = false;
      this.right = false;

      if (direction === 'left') {
        if (this.x % this.columnCount === 0) {
          this.left = true;
          return false;
        }
        this.x--;
      } else if (direction === 'right') {
        if (this.focusIndex === this.checkboxes.length - 1 || (this.x + 1) % this.columnCount === 0) {
          this.right = true;
          return false;
        }
        this.x++;
      } else if (direction === 'up') {
        if (this.y === 0) {
          this.top = true;
          return false;
        }
        this.y--;
      } else if (direction === 'down') {
        if ((this.y + 1) * this.columnCount + this.x >= this.checkboxes.length) {
          this.bottom = true;
          return false;
        }
        this.y++;
      } else if (direction === 'home') {
        this.x = 0;
        this.y = 0;
      } else if (direction === 'end') {
        this.x = this.columnCount - 1;
        this.y = this.splitItems.length - 1;
      }
      const checkbox = this.checkboxes[this.focusIndex];
      this.activedescendant = checkbox.itemId;
      if (checkbox.isDisabled) {
        if (this.navigateCheckbox(direction)) {
          return true;
        } else {
          this.x = currentX;
          this.y = currentY;
          return false;
        }
      }
      return true;
    },
    reset() {
      this.x = this.y = 0;
      this.focusCheckBox = null;
    }
  }
};
